var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"inner-component"},[_vm._t("default")],2),(_vm.description)?_c('div',{staticClass:"description-container"},[_vm._m(0),_c('div',[_c('span',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}})])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/img/1x/0info_icon.svg"),"alt":"info"}})])
}]

export { render, staticRenderFns }